import { Button, CircularProgress, Tooltip } from '@mui/material';
import { DataCellProps } from '../types';
import { MemberRoles } from 'TeamModule/constants/member';

export const MembersV2ImpersonateCell = ({
  onImpersonate,
  impersonationItem,
  isLoadingImpersonation,
  isImpersonationError,
}: DataCellProps) => {
  const hasData = Boolean(impersonationItem?.accountId && impersonationItem?.tags);
  const isStillLoading = !hasData && isLoadingImpersonation;
  // GLX-1255: No Access members cannot log in to Mosaic, so they cannot be impersonated
  const isNoAccess = impersonationItem?.roleName === MemberRoles.NoAccess;

  const getTooltipMessage = () => {
    if (isStillLoading) return 'Loading impersonation data...';
    if (isNoAccess) return 'No access to the Mosaic team';
    if (hasData) return '';
    if (isImpersonationError) return 'Failed to load impersonation data';
    return 'Impersonation data unavailable';
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onImpersonate?.(event);
  };

  if (isStillLoading) {
    return (
      <Tooltip title="Loading impersonation data...">
        <span>
          <Button
            color="primary"
            variant="outlined"
            disabled
            aria-label="Loading impersonation data"
            aria-busy="true"
          >
            <CircularProgress size={18} aria-hidden="true" />
          </Button>
        </span>
      </Tooltip>
    );
  }

  const isDisabled = !hasData || isNoAccess;

  return (
    <Tooltip title={getTooltipMessage()}>
      <span>
        <Button
          color="primary"
          variant="outlined"
          onClick={isDisabled ? undefined : handleClick}
          disabled={isDisabled}
        >
          Impersonate
        </Button>
      </span>
    </Tooltip>
  );
};

export default MembersV2ImpersonateCell;
